export default __webpack_public_path__ + "static/media/auth-background.c2bb317d.svg";